<template>
    <div class="banner-box">
        <div v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in list" :key="item.id">
                    <a :href="`${item.imgLink ? item.imgLink : 'javascript: void(0)'}`" target="_blank">
                        <img :src="item.imgUrl">
                    </a>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import { directive } from 'vue-awesome-swiper'

    export default {
        name: 'TravelNotesSwiper',
        directives: {
            swiper: directive,
        },
        props: {
            list: {
                type: Array,
                default: function () {
                    return []
                },
            },
        },
        data () {
            return {
                swiperOption: {
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                },
            }
        },
    }
</script>

<style lang="less" scoped>
    .banner-box {
        width: 100%;
        a {
            display: block;
            width: 100%;
        }
    }
    .swiper-container {
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        width: 100%;
        .swiper-wrapper {
            position: relative;
            z-index: 1;
            display: flex;
            transition-property: transform;
            box-sizing: content-box;
            width: 100%;
            height: 100%;
            .swiper-slide {
                flex-shrink: 0;
                position: relative;
                transition-property: transform;
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                }
            }
        }
    }
    .swiper-pagination {
        position: absolute;
        left: 0;
        bottom: 10px;
        z-index: 10;
        width: 100%;
        text-align: center;
        transition: 0.3s opacity;
        transform: translate3d(0, 0, 0);
    }
    .swiper-pagination /deep/ .swiper-pagination-bullet {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin: 0 4px;
        border-radius: 100%;
        background: #000;
        opacity: 0.2;
    }
    .swiper-pagination /deep/ .swiper-pagination-bullet-active {
        opacity: 1;
        background: #007aff;
    }
</style>
